import React, {useState, useContext, useEffect} from 'react';
import {View, Pressable, useWindowDimensions, Platform} from 'react-native';
import Text from '../../components/elements/Text';
import IconButton from '../../components/elements/IconButton';
import Divider from '../../components/elements/Divider';
import ProductCatalog from '../../components/modules/ProductCatalog';
import BuyAgainProduct from '../../components/modules/BuyAgainProduct';
import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../theme';
import {KEYS} from '../../utils/Constants';
import {shopContext} from '../../contexts/ShopContext';
import UI from './ui';
import CommonStyles from '../../utils/CommonStyles';
import {tID} from '../../utils/TestIdHelper';
import {TabView} from 'react-native-tab-view';
import SearchFilterView from '../../components/modules/SearchFilterView';
import {CartIcon} from '../../utils/SvgIcons';
import {eligibilityCheckContext} from '../../contexts/EligibilityCheckContext';
import {getData} from '../../utils/GeneralStorage';

const TabBarView = props => <TabView {...props} />;

export const FilterSearchBar = props => <SearchFilterView {...props} />;

const Shopping = ({navigation, setProductBeingViewed, ...props}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const [index, setIndex] = React.useState(0);
  const [routes] = useState(
    Platform.OS === 'web'
      ? [{key: 'catelog', title: 'Catalog'}]
      : [
          {key: 'catelog', title: 'Catalog'},
          {key: 'buyAgain', title: 'Buy Again'},
        ],
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [searchFilterEnabled, setSearchFilterEnabled] = useState(false);

  const layout = useWindowDimensions();
  const ShopC = useContext(shopContext);
  const ecc = useContext(eligibilityCheckContext);

  useEffect(() => {
    ecc?.showPopupOnInEligibility(navigation);
  }, [ecc, navigation]);

  const renderScene = ({route, jumpTo}) => {
    switch (route.key) {
      case 'catelog':
        return (
          <ProductCatalog
            navigation={navigation}
            searchTerm={searchTerm}
            searchFilterEnabled={searchFilterEnabled}
            selectedFilters={selectedFilters}
            setSearchFilterEnabled={setSearchFilterEnabled}
            setSelectedFilters={setSelectedFilters}
            setProductBeingViewed={setProductBeingViewed}
          />
        );
      case 'buyAgain':
        return (
          <BuyAgainProduct
            searchTerm={searchTerm}
            searchFilterEnabled={searchFilterEnabled}
            selectedFilters={selectedFilters}
            setSearchFilterEnabled={setSearchFilterEnabled}
            setSelectedFilters={setSelectedFilters}
          />
        );
    }
  };

  const renderHeaderRightItems = () => {
    return (
      <View
        testID={tID('Shopping-View-CartIconContainer')}
        style={styles.flexRow}>
        <IconButton
          testID={tID('Shopping-IconButton-Cart')}
          imageSize={26}
          leftImage={<CartIcon />}
          tintColor={colors.textPrimary}
          onPress={() => navigation.navigate('MyCart')}
        />
        {ShopC.cartProducts.length > 0 && (
          <View
            testID={tID('Shopping-View-CartStatusDot')}
            style={styles.cartStatusDot}
          />
        )}
      </View>
    );
  };

  const renderTabBar = ({navigationState, jumpTo}) => (
    <>
      <View
        testID={tID('Shopping-View-TabContainer')}
        style={
          Platform.OS === 'web' ? CommonStyles.flex_row : styles.tabbarView
        }>
        {navigationState.routes.map((route, index) => {
          const isSelected = index == navigationState.index;
          return (
            <Pressable
              testID={tID(`Shopping-Pressable-Tab${index + 1}`)}
              key={index}
              onPress={() => jumpTo(route.key)}
              style={Platform.OS !== 'web' && styles.tabbarContainer}>
              <Text
                testID={tID(`Shopping-Text-TabName${index + 1}`)}
                lineHeight={27}
                color={isSelected ? colors.link : colors.textMuted}
                variation={isSelected ? 'Subtitle1Bold' : 'Subtitle1Regular'}
                style={Platform.OS === 'web' && styles.tabText}>
                {route.title}
              </Text>
              {isSelected && (
                <Divider
                  style={styles.fullWidth}
                  top={2}
                  height={Platform.OS === 'web' ? 3 : 2}
                  color={colors.link}
                />
              )}
            </Pressable>
          );
        })}
      </View>
      <Divider top={Platform.OS === 'web' ? 0 : -1} />
    </>
  );

  const uiProps = {
    navigation,
    renderHeaderRightItems,
    searchTerm,
    selectedFilters,
    setSelectedFilters,
    setSearchTerm,
    ...props,
  };

  return (
    <UI {...uiProps}>
      <TabBarView
        swipeEnabled={false}
        navigationState={{index, routes}}
        renderScene={renderScene}
        onIndexChange={setIndex}
        initialLayout={{width: layout.width}}
        renderTabBar={renderTabBar}
      />
    </UI>
  );
};

export default Shopping;
